const DB_NAME = 'flc-mobile-offline-v1';
const STORE_NAME = 'kv';
const FALLBACK_PREFIX = 'flc.mobile.offline.db.';

let dbPromise = null;

function openDb() {
  if (dbPromise) return dbPromise;
  if (typeof indexedDB === 'undefined') return Promise.resolve(null);

  dbPromise = new Promise((resolve) => {
    try {
      const request = indexedDB.open(DB_NAME, 1);
      request.onupgradeneeded = () => {
        const db = request.result;
        if (!db.objectStoreNames.contains(STORE_NAME)) db.createObjectStore(STORE_NAME);
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => resolve(null);
    } catch (_) {
      resolve(null);
    }
  });

  return dbPromise;
}

export async function dbGet(key, fallback = null) {
  const db = await openDb();
  if (!db) {
    try {
      const raw = localStorage.getItem(`${FALLBACK_PREFIX}${key}`);
      return raw == null ? fallback : JSON.parse(raw);
    } catch (_) {
      return fallback;
    }
  }

  return new Promise((resolve) => {
    try {
      const tx = db.transaction(STORE_NAME, 'readonly');
      const request = tx.objectStore(STORE_NAME).get(key);
      request.onsuccess = () => resolve(request.result === undefined ? fallback : request.result);
      request.onerror = () => resolve(fallback);
    } catch (_) {
      resolve(fallback);
    }
  });
}

export async function dbSet(key, value) {
  const db = await openDb();
  if (!db) {
    try {
      localStorage.setItem(`${FALLBACK_PREFIX}${key}`, JSON.stringify(value));
      return true;
    } catch (_) {
      return false;
    }
  }

  return new Promise((resolve) => {
    try {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      tx.objectStore(STORE_NAME).put(value, key);
      tx.oncomplete = () => resolve(true);
      tx.onerror = () => resolve(false);
      tx.onabort = () => resolve(false);
    } catch (_) {
      resolve(false);
    }
  });
}

export async function dbDelete(key) {
  const db = await openDb();
  if (!db) {
    try { localStorage.removeItem(`${FALLBACK_PREFIX}${key}`); } catch (_) {}
    return;
  }

  await new Promise((resolve) => {
    try {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      tx.objectStore(STORE_NAME).delete(key);
      tx.oncomplete = resolve;
      tx.onerror = resolve;
      tx.onabort = resolve;
    } catch (_) {
      resolve();
    }
  });
}
